// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: inline-block;
  max-width: 24rem;
  width: 100%;
  text-align: center;
}

.credentials {
  background-color: #e9ecef;
  color: #6c757d;
  text-align: center;
  padding: 1.25rem;
  border-radius: 0.25rem;
  margin: 0.875rem 0.625rem;
}
.credentials p.instructions {
  font-weight: 700;
}
.credentials p.instructions + p {
  margin-top: -10px;
}
.credentials .invalid {
  background-color: rgb(253.9024896266, 246.5539419087, 244.5975103734);
  color: #e84e25;
  border: 0.0625rem solid rgb(241.734439834, 152.9128630705, 129.265560166);
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}
.credentials .invalid p {
  margin: 0.125rem;
}

.actions {
  display: flex;
  margin: 0 -0.125rem;
}
.actions > * {
  margin: 0 0.125rem;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/auth.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,yBCES;EDDT,cCMS;EDLT,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAME;EACE,qEAAA;EACA,cCtBE;EDuBF,yEAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,gBAAA;AAJN;;AASA;EACE,aAAA;EACA,mBAAA;AANF;AAQE;EACE,kBAAA;AANJ","sourcesContent":["@import 'variables';\n@import 'functions';\n\n.content {\n  display: inline-block;\n  max-width: 24rem;\n  width: 100%;\n  text-align: center;\n}\n\n.credentials {\n  background-color: $gray-200;\n  color: $gray-600;\n  text-align: center;\n  padding: rem(20);\n  border-radius: rem(4);\n  margin: rem(14) rem(10);\n\n  p.instructions {\n    font-weight: 700;\n\n    + p {\n      margin-top: -10px;\n    }\n  }\n\n  .invalid {\n    background-color: lighten($red, 45);\n    color: $red;\n    border: rem(1) solid lighten($red, 20);\n    border-radius: rem(4);\n    margin-bottom: rem(16);\n\n    p {\n      margin: rem(2);\n    }\n  }\n}\n\n.actions {\n  display: flex;\n  margin: 0 rem(-2);\n\n  & > * {\n    margin: 0 rem(2);\n  }\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
